// extracted by mini-css-extract-plugin
export default {"toast":"toast__z7MZf","error":"error__ECKka","support":"support__TA1Qz","success":"success__nqmEI","reloadpagewrapper":"reloadpagewrapper__T7Uxb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"toast\":\"toast__z7MZf\",\"error\":\"error__ECKka\",\"support\":\"support__TA1Qz\",\"success\":\"success__nqmEI\",\"reloadpagewrapper\":\"reloadpagewrapper__T7Uxb\"}";
        // 1787130557201
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  